import { Box, Toolbar } from "@material-ui/core";
import * as React from "react";

import LogoImage from "@assets/image/logo_gradation01.png";

import { useTopBarStyles } from "./topBarStyles";

// ログイン前のPC用。遷移リンクや操作を追加しない。
export const PublicHeader: React.FC = () => {
  const classes = useTopBarStyles();
  return (
    <Box component="header" className={classes.appBar}>
      <Toolbar disableGutters className={classes.toolBar}>
        <img src={LogoImage} alt="Propally" className={classes.logoImage} />
      </Toolbar>
    </Box>
  );
};
